import * as z from "zod";
import { Block } from "./Block";
export const TestResult = z.object({
    version: z.string(),
    blocks: Block.array(),
    is_passed: z.boolean(),
});
